module.exports = __webpack_public_path__ + "static/img/27.f828433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/27.png
// module id = kfU7
// module chunks = 1